function floorToSignificant(value: number, significant: number): number {
  const digits = Math.floor(Math.log10(value)) + 1
  const factor = 10 ** Math.max(0, digits - significant)
  return Math.floor(value / factor) * factor
}

function stripTrailingZero(value: number): string {
  return Number(value.toFixed(1)).toString()
}

export function formatStatValue(value: number | undefined | null): string {
  if (value == null || value <= 0) {
    return '0'
  }

  const floored = floorToSignificant(value, 2)

  if (floored >= 1_000_000_000) {
    return `${stripTrailingZero(floored / 1_000_000_000)}B+`
  }
  if (floored >= 1_000_000) {
    return `${stripTrailingZero(floored / 1_000_000)}M+`
  }
  if (floored >= 1000) {
    return `${stripTrailingZero(floored / 1000)}K+`
  }
  return `${floored}+`
}
